/* ARTD matching-family set builder (Max, Oct 7-8 2026).
   One card per cat: the family side by side, ONE colour for everyone, a size per person, and one button that puts
   the whole set in the bag. Used on the homepage and the Family page.
   People (Max, Oct 8): it starts with a woman, a man, a girl and a boy; "+ Woman" "+ Man" "+ Girl" "+ Boy" add more,
   and every row can be removed, so any family can build itself (two moms, two dads, three boys...).
   The tees are unisex: woman / man use the adult tee (their photos: the woman with long hair and the man with a
   hand in his pocket come first, see setup-adult.js), girl / boy use the kids' tee.
   Markup: <div data-cx-family><script type="application/json" data-cx-family-data>{design, name, color, i,
   versions: [cx-fjson, ...]}</script></div>. The card API is on root._family. */
(function () {
  'use strict';
  var MAX_PEOPLE = 8;
  var NAME = { woman: 'Woman', man: 'Man', girl: 'Girl', boy: 'Boy', toddler: 'Toddler' };
  function esc(s) { return window.CX ? CX.esc(s) : String(s == null ? '' : s); }
  function money(c) { return window.CX ? CX.money(c) : '$' + (c / 100).toFixed(2); }
  function sized(u, w) { return !u ? '' : u.replace(/([?&])width=\d+/, '$1width=' + w); }
  function range(v) { var s = v.sizes || []; return s.length > 1 ? s[0] + '–' + s[s.length - 1] : s[0] || ''; }
  function isAdult(k) { return k === 'woman' || k === 'man'; }

  function mount(root) {
    if (!root || root._family) return;
    var node = root.querySelector('[data-cx-family-data]');
    if (!node) return;
    var data;
    try { data = JSON.parse(node.textContent); } catch (e) { return; }
    var vers = data.versions || [];
    var adults = vers.filter(function (v) { return v.who === 'adult'; });
    var her = adults.find(function (v) { return v.fit === 'women'; }) || adults.find(function (v) { return v.fit === 'unisex'; });
    var him = adults.find(function (v) { return v.fit === 'men'; }) || adults.find(function (v) { return v.fit === 'unisex'; });
    var kid = vers.find(function (v) { return v.who === 'kids'; });
    var tod = vers.find(function (v) { return v.who === 'toddler'; });
    var VER = { woman: her, man: him, girl: kid, boy: kid, toddler: tod };

    /* colours every version comes in, in the first version's order (lightest first) */
    var common = (vers[0] ? vers[0].colors : []).map(function (c) { return c.n; }).filter(function (n) {
      return vers.every(function (v) { return v.colors.some(function (c) { return c.n === n; }); });
    });
    if (!common.length && vers[0]) common = vers[0].colors.map(function (c) { return c.n; });
    /* the colour a set starts in: a given one, else a rich colour (white sets look pale), a different one per set on
       the Family page (data.i = the set's number), else the kids' card colour */
    var PREF = ['Navy', 'Black', 'Forest', 'Maroon', 'Team Purple', 'Pink', 'Berry', 'Vintage Black', 'Heather Team Purple', 'Asphalt'];
    var rot = PREF.slice((data.i || 0) % PREF.length).concat(PREF.slice(0, (data.i || 0) % PREF.length));
    var color = [data.color].concat(rot, [kid && kid.card, tod && tod.card, her && her.card]).filter(function (n) { return n && common.indexOf(n) > -1; })[0] || common[0];

    var uid = 0, people = [];
    function person(kind) { return { id: ++uid, kind: kind, size: '' }; }
    ['woman', 'man', 'girl', 'boy'].forEach(function (k) { if (VER[k]) people.push(person(k)); });
    if (!kid && tod) people.push(person('toddler'));

    function colorOf(v, name) { return v.colors.find(function (c) { return c.n === name; }) || v.colors[0] || {}; }
    function variant(v, size) {
      var ci = v.colors.findIndex(function (c) { return c.n === color; });
      var si = (v.sizes || []).indexOf(size);
      if (!v.sizes || !v.sizes.length) si = 0;
      return v.v.find(function (x) { return x[0] === Math.max(ci, 0) && x[1] === si; });
    }
    function nth(p) { return people.filter(function (q) { return q.kind === p.kind; }).indexOf(p); }
    function label(p) {
      var same = people.filter(function (q) { return q.kind === p.kind; });
      return NAME[p.kind] + (same.length > 1 ? ' ' + (same.indexOf(p) + 1) : '');
    }
    /* the photo for a person: a model of the right kind in this colour, else the flat tee.
       Two women (or two men) get two different models; toddlers alternate girl, boy. */
    function photo(p) {
      var v = VER[p.kind], c = colorOf(v, color), i = Math.max(0, nth(p));
      if (isAdult(p.kind)) {
        var list = (p.kind === 'woman' ? c.w : c.m) || [];
        if (typeof list === 'string') list = list ? [list] : [];
        return list.length ? { src: list[i % list.length], worn: true } : { src: c.f, worn: false };
      }
      var want = p.kind === 'boy' ? c.b : p.kind === 'girl' ? c.g : (i % 2 ? c.b : c.g);
      return want ? { src: want, worn: true } : { src: c.f, worn: false };
    }

    root.classList.add('cc-set');
    /* locked (snippets/cx-family-locked.liquid = 1): just the family photos with "Coming soon", nothing to order */
    if (data.locked) {
      root.classList.add('is-locked');
      root.innerHTML = node.outerHTML + '<div class="cc-set__stage" data-stage></div>' +
        '<p class="cc-set__soon"><b>Coming soon</b><span>Matching family sets are almost here. Every cat already comes in kids&rsquo; and adult sizes.</span></p>';
      stage = root.querySelector('[data-stage]');
      drawStage();
      root._family = { setColor: function () { return false; }, colors: common.slice(), get color() { return color; }, design: data.design, locked: true };
      return;
    }
    root.innerHTML = node.outerHTML +
      '<div class="cc-set__stage" data-stage></div>' +
      '<div class="cc-set__colors"><p class="cc-set__clabel">Color: <b data-cname></b><span>same for everyone</span></p><div class="cc-set__dots" role="group" aria-label="Color for the whole set" data-dots></div></div>' +
      '<div class="cc-set__rows" data-rows></div>' +
      '<div class="cc-set__more" data-more></div>' +
      '<button type="button" class="cx-btn cc-btn cc-set__add" data-add disabled></button>' +
      '<p class="cc-set__note" data-note></p>';
    var stage = root.querySelector('[data-stage]'), dots = root.querySelector('[data-dots]'), rows = root.querySelector('[data-rows]');
    var more = root.querySelector('[data-more]'), addBtn = root.querySelector('[data-add]'), note = root.querySelector('[data-note]');
    var cname = root.querySelector('[data-cname]');

    dots.innerHTML = common.map(function (n) {
      var c = colorOf(vers[0], n);
      return '<button type="button" class="cc-set__dot" data-color="' + esc(n) + '" title="' + esc(n) + '" aria-label="' + esc(n) + '" style="--c:' + esc(c.hex) + '"></button>';
    }).join('');

    function drawStage() {
      if (!people.length) { stage.innerHTML = '<p class="cc-set__empty">Add your family below</p>'; stage.style.setProperty('--n', 0); return; }
      /* rows with no model photo show the flat tee; the same flat twice is shown once */
      var seen = {}, figs = [];
      people.forEach(function (p) {
        var ph = photo(p), k = ph.src;
        if (!ph.worn && seen[k]) { seen[k].cap = isAdult(p.kind) ? 'Grown-ups' : 'Kids'; return; }
        var f = { p: p, ph: ph, cap: label(p) };
        if (!ph.worn) seen[k] = f;
        figs.push(f);
      });
      stage.innerHTML = figs.map(function (f) {
        var cls = isAdult(f.p.kind) ? 'adult' : f.p.kind === 'toddler' ? 'tod' : 'kid';
        return '<figure class="cc-set__fig cc-set__fig--' + cls + (f.ph.worn ? '' : ' is-flat') + '">' +
          '<span class="cc-set__pic"><img src="' + esc(sized(f.ph.src, 700)) + '" alt="' + esc(data.name + ' tee in ' + color + ', ' + NAME[f.p.kind].toLowerCase()) + '" width="700" height="700" loading="lazy"></span>' +
          '<figcaption>' + esc(f.cap) + '</figcaption></figure>';
      }).join('');
      stage.style.setProperty('--n', figs.length);
    }
    function drawRows() {
      rows.innerHTML = people.map(function (p) {
        var v = VER[p.kind], c = colorOf(v, color), pick = p.size && variant(v, p.size);
        var sub = isAdult(p.kind) ? 'Adult tee · ' + range(v) + (p.kind === 'woman' && v.fit === 'unisex' ? ' · relaxed fit' : '')
          : p.kind === 'toddler' ? 'Toddler tee · ' + range(v) : 'Kids’ tee · youth ' + range(v);
        var opts = '<option value="">Size</option>' + (v.sizes || []).map(function (s) {
          var x = variant(v, s), ok = x && x[3];
          return '<option value="' + esc(s) + '"' + (ok ? '' : ' disabled') + (p.size === s ? ' selected' : '') + '>' + esc(s) + (ok ? '' : ' (sold out)') + '</option>';
        }).join('');
        var lb = label(p);
        var see = { woman: 'her', man: 'him', girl: 'girl', boy: 'boy' }[p.kind] || '';
        var url = v.url + (see ? (v.url.indexOf('?') > -1 ? '&' : '?') + 'see=' + see : '');
        return '<div class="cc-set__row" data-id="' + p.id + '">' +
          '<a class="cc-set__thumb" href="' + esc(url) + '" aria-label="See the tee for the ' + esc(lb.toLowerCase()) + '"><img src="' + esc(sized(c.f, 160)) + '" alt="" width="80" height="80" loading="lazy"></a>' +
          '<span class="cc-set__who"><b>' + esc(lb) + '</b><small>' + esc(sub) + '</small></span>' +
          '<span class="cc-set__pick"><select class="cc-set__size" data-size aria-label="Size for ' + esc(lb) + '">' + opts + '</select></span>' +
          '<span class="cc-set__price">' + money(pick ? pick[4] : v.price) + '</span>' +
          '<button type="button" class="cc-set__x" data-remove aria-label="Remove ' + esc(lb) + '">&times;</button>' +
          '</div>';
      }).join('');
      var full = people.length >= MAX_PEOPLE;
      more.innerHTML = ['woman', 'man', 'girl', 'boy', 'toddler'].filter(function (k) { return VER[k] && (k !== 'toddler' || tod); }).map(function (k) {
        return '<button type="button" data-more-kind="' + k + '"' + (full ? ' disabled' : '') + '>+ ' + NAME[k] + '</button>';
      }).join('');
    }
    function drawTotal() {
      var missing = people.filter(function (p) { return !p.size; });
      var list = people.filter(function (p) { return p.size; }).map(function (p) { return variant(VER[p.kind], p.size); }).filter(Boolean);
      var total = list.reduce(function (t, x) { return t + x[4]; }, 0);
      if (!people.length) { addBtn.disabled = true; addBtn.textContent = 'Add someone to your set'; note.textContent = ''; return; }
      if (missing.length) {
        addBtn.disabled = true;
        addBtn.textContent = missing.length === people.length ? 'Pick a size for everyone' : 'Pick a size for ' + label(missing[0]);
        note.textContent = 'Remove anyone who doesn’t need a tee with the ×.';
        return;
      }
      addBtn.disabled = false;
      addBtn.textContent = 'Add ' + list.length + (list.length === 1 ? ' tee' : ' matching tees') + ' · ' + money(total);
      note.textContent = total >= 3000 ? 'This set ships free in the US.' : 'Free US shipping on orders $30+.';
    }
    function draw() {
      cname.textContent = color;
      Array.prototype.forEach.call(dots.children, function (d) { d.setAttribute('aria-pressed', d.getAttribute('data-color') === color ? 'true' : 'false'); });
      drawStage(); drawRows(); drawTotal();
    }
    function setColor(n) {
      if (common.indexOf(n) < 0) return false;
      color = n;
      /* a size that isn't made in the new colour is cleared, so nobody gets a surprise */
      people.forEach(function (p) { if (p.size) { var x = variant(VER[p.kind], p.size); if (!x || !x[3]) p.size = ''; } });
      draw();
      return true;
    }

    root.addEventListener('click', function (e) {
      var d = e.target.closest('[data-color]');
      if (d && dots.contains(d)) { setColor(d.getAttribute('data-color')); return; }
      var r = e.target.closest('[data-more-kind]');
      if (r && !r.disabled) {
        if (people.length >= MAX_PEOPLE) return;
        var np = person(r.getAttribute('data-more-kind'));
        /* a new person goes after the last one of the same kind (Woman 1, Woman 2, Man...); grown-ups stay above kids */
        var at = -1;
        people.forEach(function (q, i) { if (q.kind === np.kind) at = i; });
        if (at < 0 && isAdult(np.kind)) people.forEach(function (q, i) { if (isAdult(q.kind) && (np.kind === 'man' || q.kind === 'woman')) at = i; });
        if (at < 0) at = isAdult(np.kind) ? -1 : people.length - 1;
        people.splice(at + 1, 0, np);
        draw();
        var row = rows.querySelector('[data-id="' + np.id + '"]'), sel = row && row.querySelector('[data-size]');
        if (sel) sel.focus();
        return;
      }
      var x = e.target.closest('[data-remove]');
      if (x) {
        var id = +x.closest('[data-id]').getAttribute('data-id');
        people = people.filter(function (p) { return p.id !== id; });
        draw();
        return;
      }
      if (e.target.closest('[data-add]') && !addBtn.disabled && window.CX) {
        var items = {};
        people.filter(function (p) { return p.size; }).forEach(function (p) {
          var vx = variant(VER[p.kind], p.size); if (!vx || !vx[3]) return;
          items[vx[2]] = (items[vx[2]] || 0) + 1;
        });
        var list = Object.keys(items).map(function (vid) { return { id: +vid, qty: items[vid] }; });
        if (list.length) CX.addMany(list, addBtn).then(drawTotal);
      }
    });
    root.addEventListener('change', function (e) {
      if (!e.target.hasAttribute('data-size')) return;
      var row = e.target.closest('[data-id]'); if (!row) return;
      var id = +row.getAttribute('data-id'), p = people.find(function (q) { return q.id === id; }); if (!p) return;
      p.size = e.target.value;
      drawRows(); drawTotal();
    });

    root._family = { setColor: setColor, colors: common.slice(), get color() { return color; }, design: data.design };
    draw();
  }

  function init() { Array.prototype.forEach.call(document.querySelectorAll('[data-cx-family]'), mount); }
  /* deferred scripts run before DOMContentLoaded, and cx-kit.js (window.CX) may come after this one */
  if (document.readyState === 'complete') init(); else document.addEventListener('DOMContentLoaded', init);
  window.CXFamily = { mount: mount };
})();
